import { makeVar, ReactiveVar } from "@apollo/client";

// Define the structure of the result data
interface ResultState {
    loading: boolean;
    response: any; // Replace `any` with the actual type of the response if known
    justResult: boolean;
    statusCode: number | null;
}

// Create the reactive variable with the defined structure
const result: ReactiveVar<ResultState> = makeVar<ResultState>({
    loading: false,
    response: null,
    justResult: false,
    statusCode: null
});

export default result;
